import React, { useEffect, useState } from 'react';
import HomeContent from './HomeContent';
import AboutContent from './AboutContent';
import { useLanguage } from './LanguageContext';

const LATITUDE = 57.080889;
const LONGITUDE = 12.257694;

const AppContent = () => {
  const { language } = useLanguage();
  const [showHomeContent, setShowHomeContent] = useState(true);
  const [seaTemperature, setSeaTemperature] = useState(null);
  const [spotData, setSpotData] = useState({ weather: null, marine: null });

  useEffect(() => {
    const fetchSpotData = async () => {
      try {
        const weatherUrl = `https://api.open-meteo.com/v1/forecast?latitude=${LATITUDE}&longitude=${LONGITUDE}&current=temperature_2m,apparent_temperature,wind_speed_10m,wind_direction_10m,weather_code,is_day&hourly=temperature_2m,wind_speed_10m,wind_direction_10m,soil_temperature_0cm,weather_code,is_day&daily=weather_code,temperature_2m_max,temperature_2m_min,wind_speed_10m_max,wind_direction_10m_dominant&forecast_days=10&timezone=auto`;
        const marineUrl = `https://marine-api.open-meteo.com/v1/marine?latitude=${LATITUDE}&longitude=${LONGITUDE}&hourly=wave_height,wave_direction,wave_period,swell_wave_height,swell_wave_direction,swell_wave_period,sea_surface_temperature&forecast_days=10&timezone=auto&cell_selection=sea`;

        const [weatherResponse, marineResponse] = await Promise.all([
          fetch(weatherUrl),
          fetch(marineUrl),
        ]);

        const [weatherData, marineData] = await Promise.all([
          weatherResponse.json(),
          marineResponse.json(),
        ]);

        if (Array.isArray(marineData?.hourly?.sea_surface_temperature)) {
          const seaTemps = marineData.hourly.sea_surface_temperature.filter((value) => typeof value === 'number');
          if (seaTemps.length) {
            const sum = seaTemps.reduce((acc, curr) => acc + curr, 0);
            setSeaTemperature(Math.round(sum / seaTemps.length));
          }
        } else if (Array.isArray(weatherData?.hourly?.soil_temperature_0cm)) {
          const seaTempArray = weatherData.hourly.soil_temperature_0cm;
          const sum = seaTempArray.reduce((acc, curr) => acc + curr, 0);
          const averageTemperature = Math.round(sum / seaTempArray.length);
          setSeaTemperature(averageTemperature);
        }

        setSpotData({ weather: weatherData, marine: marineData });
      } catch (error) {
        console.error('Error fetching surf spot data:', error);
      }
    };

    fetchSpotData();
  }, []);

  return (
    <main className="app-shell">
      <nav className="section-nav" aria-label="Sections">
        <button
          className={showHomeContent ? 'nav-chip active' : 'nav-chip'}
          onClick={() => setShowHomeContent(true)}
        >
          <img
  src={`${process.env.PUBLIC_URL}/static/icons/general/overview_icon.png`} alt="" className="icon-md" />
          <span>{language === 'english' ? 'Overview' : 'Översikt'}</span>
        </button>
        <button
          className={!showHomeContent ? 'nav-chip active' : 'nav-chip'}
          onClick={() => setShowHomeContent(false)}
        >
          <img
  src={`${process.env.PUBLIC_URL}/static/icons/general/about_icon.png`} alt="" className="icon-md" />
          <span>{language === 'english' ? 'About' : 'Om'}</span>
        </button>
      </nav>

      {showHomeContent ? (
        <HomeContent spotData={spotData} seaTemperature={seaTemperature} language={language} />
      ) : (
        <AboutContent language={language} />
      )}
    </main>
  );
};

export default AppContent;
